import productApi from "@/api/product";

export function createListingPdfFilters(options = {}) {
  return {
    page: 1,
    size: 999,
    availability: [options.inventory],
    productTypes: options.productTypes || [],
    show: options.show || "AVAILABLE_UPCOMING",
    tax: options.tax || localStorage.getItem("tax") || "IN",
  };
}

export function fetchListingPdfUrl(filters) {
  return productApi.downloadPDF(filters);
}
